/* eslint-disable no-undef */
export const useFabricStore = defineStore("fabric", () => {
  // STATE ------------------------------------------------------------------

  const canvasWidth = ref(null);
  const canvasHeight = ref(null);
  const canvasScaleFactor = ref(null);

  // ACTIONS ----------------------------------------------------------------

  function setCanvasWidth(payload) {
    canvasWidth.value = payload;
  }
  function setCanvasHeight(payload) {
    canvasHeight.value = payload;
  }
  function setCanvasScaleFactor(payload) {
    canvasScaleFactor.value = payload;
  }
  function setCanvasDimensions(payload) {
    setCanvasWidth(payload.width);
    setCanvasHeight(payload.height);
  }
  return {
    canvasWidth,
    canvasHeight,
    canvasScaleFactor,
    setCanvasDimensions,
    setCanvasScaleFactor
  };
});